enum EventType {
  ART_SHOW = 'ART_SHOW',
  AWARDS_CEREMONY = 'AWARDS_CEREMONY',
  BAND_CONCERT = 'BAND_CONCERT',
  BANQUET = 'BANQUET',
  CHOIR_CONCERT = 'CHOIR_CONCERT',
  DANCE_PERFORMANCE = 'DANCE_PERFORMANCE',
  MUSIC_CONCERT = 'MUSIC_CONCERT',
  ORCHESTRA_CONCERT = 'ORCHESTRA_CONCERT',
  PRESENTATION = 'PRESENTATION',
  RECEPTION = 'RECEPTION',
  THEATRE_PERFORMANCE = 'THEATRE_PERFORMANCE',
  CHURCH_SERVICE = 'CHURCH_SERVICE'
}

export const getEventTypeFromLabel = (label: string) => {
  // @ts-ignore
  return EventType[label.replace(' ', '_').toUpperCase()]
}

export const getEventTypeLabel = (eventType: EventType) => {
  return eventType
    .toLowerCase()
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.substring(1))
    .join(' ')
}

export default EventType
